import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#F8F8F5]/95 backdrop-blur-md shadow-md' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div 
            className="cursor-pointer flex items-center"
            onClick={() => scrollToSection('hero')}
          >
            {/* Logo Image - icône bâtiment doré transparente */}
            <img 
              src="/logo-icon-only.png"
              alt="Esprit Ouest"
              className="h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('concept')}
              className={`text-sm font-medium transition-colors hover:text-white font-bold ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Concept
            </button>
            <button
              onClick={() => scrollToSection('espaces')}
              className={`text-sm font-medium transition-colors hover:text-white font-bold ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Nos Espaces
            </button>
            <button
              onClick={() => scrollToSection('lieux')}
              className={`text-sm font-medium transition-colors hover:text-white font-bold ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Lieux
            </button>
            <button
              onClick={() => scrollToSection('avantages')}
              className={`text-sm font-medium transition-colors hover:text-white font-bold ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Avantages
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FFFFFF] hover:bg-[#E5E7EB] text-[#4A6B96] font-semibold"
            >
              Nous Contacter
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-[#4A6B96]' : 'text-white'} size={24} />
            ) : (
              <Menu className={isScrolled ? 'text-[#4A6B96]' : 'text-white'} size={24} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-4 bg-[#F8F8F5] rounded-lg shadow-lg p-6">
            <button
              onClick={() => scrollToSection('concept')}
              className="text-sm font-medium text-gray-700 hover:text-white font-bold text-left"
            >
              Concept
            </button>
            <button
              onClick={() => scrollToSection('espaces')}
              className="text-sm font-medium text-gray-700 hover:text-white font-bold text-left"
            >
              Nos Espaces
            </button>
            <button
              onClick={() => scrollToSection('lieux')}
              className="text-sm font-medium text-gray-700 hover:text-white font-bold text-left"
            >
              Lieux
            </button>
            <button
              onClick={() => scrollToSection('avantages')}
              className="text-sm font-medium text-gray-700 hover:text-white font-bold text-left"
            >
              Avantages
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#FFFFFF] hover:bg-[#E5E7EB] text-[#4A6B96] font-semibold w-full"
            >
              Nous Contacter
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
